import BaseController from "@/attributes/BaseController";
import InitCardService from "../service/InitCardService";

class ThirdAppController extends BaseController {
  // constructor() {
  //     super();
  // }
  listDBService: any;
  initDb() {
    this.listDBService = InitCardService.GetListService();
  }

  setCards(propertyKey: string, data: any, ...args: any[]) {
    const _propertyKey = `${propertyKey}`;
    return this.listDBService.setDBList(_propertyKey, data);
  }
  getCards(propertyKey: string) {
    const _propertyKey = `${propertyKey}`;
    return this.listDBService.getDBList(_propertyKey);
  }
}

export default new ThirdAppController();
